import { actionTypes as FirebaseActions } from 'react-redux-firebase';

import { TCreateSendMethod } from '../../../types/createSendFlow';
import * as AuthActions from '../../actions/auth';
import * as MethodActions from '../actions/method';

export const initialState: TCreateSendMethod | null = null;

const reducer = (state: TCreateSendMethod | null = initialState, action: any): TCreateSendMethod | null => {
  switch (action.type) {
    case AuthActions.ADMIN_ROLE_CHANGED:
    case AuthActions.CHANGE_ORGANIZATION_SUCCESS:
    case FirebaseActions.LOGOUT: {
      return initialState;
    }
    case MethodActions.SET_CS_METHOD: {
      return action.payload;
    }
    default:
      return state;
  }
};

export default reducer;
